import "twin.macro";

import { useParams } from "react-router";

import { Skeleton } from "@mui/material";

import { Contained } from "@components/StyledComponents";
import { useOrderWindowQuery } from "@features/orderWindows/data";
import OrderWindowFormTiles from "@features/orderWindows/orderWindowForm/OrderWindowForm";
import { Title } from "@features/ui";
import DocTitle from "@utility/DocTitle";

import ErrorPage from "./ErrorPage";

const OrderWindowSkeleton = () => {
  return (
    <div tw="grid gap-x-4 gap-y-6 lg:grid-cols-[2fr 1fr]">
      {/* Form side skeleton */}
      <div tw="space-y-4">
        <Skeleton variant="rounded" height={250} tw="rounded-xl" />
        <Skeleton variant="rounded" height={150} tw="rounded-xl" />
      </div>
      {/* Info tile skeleton */}
      <Skeleton variant="rounded" height={300} tw="rounded-xl" />
    </div>
  );
};
const OrderWindowPage = () => {
  const { id } = useParams<{ id?: string }>();
  const isNew = !id || id === "new";

  const {
    data: orderWindow,
    isLoading,
    error,
  } = useOrderWindowQuery(isNew ? null : id);

  if (error) return <ErrorPage error={error} />;

  return (
    <>
      <DocTitle
        title={isNew ? "New Order Window" : orderWindow?.name || "Order Window"}
      />
      <Contained tw="pb-6 max-w-screen-lg mx-auto">
        <Title backUrl="/admin/order-windows" tw="mb-4">
          {isNew ? (
            "New Order Window"
          ) : orderWindow?.name ? (
            `Editing ${orderWindow.name}`
          ) : (
            <Skeleton tw="w-48 h-8" />
          )}
        </Title>

        {isLoading && <OrderWindowSkeleton />}

        {!isLoading && (
          <OrderWindowFormTiles orderWindow={isNew ? null : orderWindow!} />
        )}
      </Contained>
    </>
  );
};

export default OrderWindowPage;
